import React, { useState, useContext, useEffect } from 'react';
import { useBreakpoint } from '../misc/useBreakpoint';
import SchoolGoat from '../assets/SchoolGoatBg.png';
import { ChevronLeft, ChevronRight, Lock, Bell, Crown, Gift } from 'lucide-react';
import { dbRefs, SEARCH_PARAMS } from '../misc/constants';
import { UserContext } from '../contexts/UserProvider';
import { logPaywallAction,  } from '../misc/utils';
import { PAYWALL_EVENTS, USER_TEST_ID, API } from '../misc/constants';
import { Pixel } from '../misc/analytics';
import axios from 'axios';


const getRandomNumberBetween = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

const getPriceObj = async (paddle, user, priceId, ) => {
  if ( !paddle ) { console.log('no paddle'); return; }

  try {

    if ( user?.authData?.country_code ) {
    const result = await paddle.PricePreview({items: [{ priceId: priceId, quantity: 1 }], address: { countryCode: user?.authData?.country_code }, });
    const results = result.data;

    const totalUnformatted = Number((results?.details?.lineItems?.[0]?.totals?.total / 100).toFixed(2))
    const interval = results?.details?.lineItems?.[0]?.price?.billingCycle?.interval
    const totalUnformattedMonthly = interval === 'month' ? totalUnformatted : Number((totalUnformatted / 12).toFixed(2))
    const currencySymbol = results?.details?.lineItems?.[0]?.formattedTotals?.total.slice(0, 1)
    const totalFormatted = `${currencySymbol}${totalUnformattedMonthly}`

    return { total: totalUnformattedMonthly, totalFormatted: totalFormatted, currencySymbol: currencySymbol };
    }

    else {
      const result = await paddle.PricePreview({ items: [{ priceId: priceId, quantity: 1 }], address: { countryCode: 'US' }, });
      const results = result.data;

      const totalUnformatted = Number((results?.details?.lineItems?.[0]?.totals?.total / 100).toFixed(2))
      const interval = results?.details?.lineItems?.[0]?.price?.billingCycle?.interval
      const totalUnformattedMonthly = interval === 'month' ? totalUnformatted : Number((totalUnformatted / 12).toFixed(2))
      const currencySymbol = results?.details?.lineItems?.[0]?.formattedTotals?.total.slice(0, 1)
      const totalFormatted = `${currencySymbol}${totalUnformattedMonthly}`

      return { total: totalUnformattedMonthly, totalFormatted: totalFormatted, currencySymbol: currencySymbol };
    }
  }
  catch (error) {
    return { total: 9.99, totalFormatted: '$9.99', currencySymbol: '$' };
  }
}

const SelectableOptions = ({ value, options, onSelect, setCurrentStep, currentStep }) => {
  const { isMobileAndBelow } = useBreakpoint();

  return (
    <div style={{ width: '100%', marginBottom: '1rem', maxWidth: '400px' }}>
      {options.map((option, index) => (
        <button style={{ width: '100%', padding: isMobileAndBelow ? '1.5rem' : '1rem', borderRadius: '50px', backgroundColor: option.isShaded ? '#f0f0f0' : 'transparent', color: '#000', border: 'none', cursor: 'pointer', marginBottom: '1rem', fontSize: '1.1rem' }}
          key={index}
          onClick={() => {
            onSelect(option.value);
          }}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

const TextInput = ({ placeholder, onSelect, value, keyboardType = 'text' }) => {
  const inputId = `input`;


  return (
    <div style={{ width: '100%', marginBottom: '1rem', maxWidth: '400px' }}>
      <input style={{ width: '100%', padding: '3rem 1rem', borderRadius: '10px', border: '1px solid #ccc', marginBottom: '1rem', fontSize: '4rem', textAlign: 'center', color: '#000', backgroundColor: '#f0f0f0', outline: 'none', 

      }}
        id={inputId}
        inputMode={'decimal'}
        placeholder={placeholder}
        onChange={(e) => onSelect(e.target.value)}
        value={value}
      />
      <style>{`#${inputId}::placeholder { color: #cccccc; }`} </style>
    </div>
  );
};

const SchoolPopularity = ({ educationLevel, school }) => {
  const { isMobileAndBelow } = useBreakpoint();

  const calculateStudentCount = () => {
    // Set base count based on education level
    if (educationLevel === 'university') {
      return Math.floor(Math.random() * 71) + 30; // 30-100 for colleges/universities
    } else if (educationLevel === 'high_school') {
      return Math.floor(Math.random() * 21) + 10; // 10-30 for high schools
    } else if (educationLevel === 'middle_school') {
      return Math.floor(Math.random() * 9) + 2; // 2-10 for middle schools
    } else {
      return Math.floor(Math.random() * 21) + 10; // Default case (same as high school)
    }
  };
  
  const studentCount = calculateStudentCount();
  const additionalCount = studentCount - 5; // Subtract the 5 students shown in the avatars
  
  return (
    <div style={{ width: '100%', textAlign: 'center', position: 'relative', padding: '2rem 1rem', alignItems: 'center', justifyContent: 'center', display: 'flex', flexDirection: 'column', }}>
     
      <h2 style={{ fontSize: isMobileAndBelow ? '2rem' : '2rem', fontWeight: '600', marginBottom: '1.2rem', color: '#333', lineHeight: '1.4', maxWidth: '400px' }}>
        <span style={{ color: 'var(--color-primary)', fontWeight: '700', backgroundColor: 'white', padding: '0.3rem 0.6rem', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.2)', fontSize: isMobileAndBelow ? '2.5rem' : '2.5rem' }}>{studentCount}</span> students at your school are already using School Goat
      </h2>
      
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '15px', position: 'relative' }}>
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} style={{ width: '38px', height: '38px', borderRadius: '50%', backgroundColor: ['#007AFF', '#5856D6', '#FF2D55', '#FF9500', '#34C759'][i % 5], display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#fff', fontSize: '1.1rem', boxShadow: '0 2px 8px rgba(0,0,0,0.15)', margin: '0 -6px', border: '2px solid white', zIndex: 5 - i }}>
            {'👤'}
          </div>
        ))}
        <div style={{ fontSize: '0.8rem', backgroundColor: '#34C759', color: 'white', padding: '2px 6px', borderRadius: '10px', fontWeight: 'bold' }}>+{additionalCount}</div>
      </div>
      
      <div style={{ marginTop: '4rem', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
        <span style={{ color: 'var(--color-text4)', fontSize: isMobileAndBelow ? '1.2rem' : '1rem' }}>Let's get you started →</span>
      </div>
    </div>
  );
};

const EducationTypePopularity = ({ studentCount, educationLevel }) => {
  const { isMobileAndBelow } = useBreakpoint();

  const educationLevelMap = {
    'middle_school': 'Middle School students',
    'high_school': 'High School students',
    'university': 'University students',
    'not_a_student': 'Non-Students'
  };
  const displayEducationLevel = educationLevelMap[educationLevel] || '';

  const additionalCount = studentCount - 5; // Subtract the 5 students shown in the avatars
  
  return (
    <div style={{ width: '100%', textAlign: 'center', position: 'relative', padding: '2rem 1rem', alignItems: 'center', justifyContent: 'center', display: 'flex', flexDirection: 'column', }}>
     
      <h2 style={{ fontSize: isMobileAndBelow ? '2rem' : '2rem', fontWeight: '600', marginBottom: '1.2rem', color: '#333', lineHeight: '1.4', maxWidth: '400px', animation: 'fadeIn 0.8s ease-out' }}>
        <span style={{ color: 'var(--color-primary)', fontWeight: '700', backgroundColor: 'white', padding: '0.3rem 0.6rem', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.2)', fontSize: isMobileAndBelow ? '2.5rem' : '2.5rem', animation: 'scaleIn 1s ease-out' }}>{studentCount.toLocaleString()}</span> {displayEducationLevel} are already using School Goat
      </h2>
      
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '15px', position: 'relative' }}>
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} style={{ width: '38px', height: '38px', borderRadius: '50%', backgroundColor: ['#007AFF', '#5856D6', '#FF2D55', '#FF9500', '#34C759'][i % 5], display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#fff', fontSize: '1.1rem', boxShadow: '0 2px 8px rgba(0,0,0,0.15)', margin: '0 -6px', border: '2px solid white', zIndex: 5 - i, animation: `slideIn 0.5s ease-out ${0.2 + i * 0.1}s both` }}>
            {'👤'}
          </div>
        ))}
        {/* <div style={{ fontSize: '0.8rem', backgroundColor: '#34C759', color: 'white', padding: '2px 6px', borderRadius: '10px', fontWeight: 'bold', animation: 'popIn 0.6s ease-out 0.8s both' }}>+{additionalCount}</div> */}
      </div>
      
      <div style={{ marginTop: '4rem', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px', animation: 'fadeInUp 0.8s ease-out 1.2s both' }}>
        <span style={{ color: 'var(--color-text4)', fontSize: isMobileAndBelow ? '1.2rem' : '1rem' }}>Let's get you started →</span>
      </div>
      
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
          
          @keyframes scaleIn {
            from { transform: scale(0.8); opacity: 0; }
            to { transform: scale(1); opacity: 1; }
          }
          
          @keyframes slideIn {
            from { transform: translateX(-20px); opacity: 0; }
            to { transform: translateX(0); opacity: 1; }
          }
          
          @keyframes popIn {
            0% { transform: scale(0); opacity: 0; }
            70% { transform: scale(1.2); }
            100% { transform: scale(1); opacity: 1; }
          }
          
          @keyframes fadeInUp {
            from { transform: translateY(10px); opacity: 0; }
            to { transform: translateY(0); opacity: 1; }
          }
        `}
      </style>
    </div>
  );
};

const GPAVisualization = ({ currentGPA, goalGPA }) => {
  const { isMobileAndBelow } = useBreakpoint();
  const currentGPAValue = parseFloat(currentGPA) || 3;
  const goalGPAValue = parseFloat(goalGPA) || 4;

  const goalGreaterThanCurrent = goalGPAValue > currentGPAValue;

  // Scale GPA values to a maximum of 4.0
  const maxGPA = 4.0;
  const maxGPAValue = Math.max(currentGPAValue, goalGPAValue);
  const gpaMultiplier = 4.0 / maxGPAValue;
  
  // Calculate effective percentages relative to 4.0 scale
  const effectiveCurrentGPA = goalGreaterThanCurrent ? currentGPAValue * gpaMultiplier : 3;
  const effectiveGoalGPA = goalGreaterThanCurrent ? goalGPAValue * gpaMultiplier : 4;

  const BAR_HEIGHT_MULTIPLIER = isMobileAndBelow ? 30 : 25;
  const BAR_WIDTH = 100;
  const HORIZONTAL_PADDING = '15%';
  

  return (
    <div style={{ width: '100%', textAlign: 'center', maxWidth: '400px' }}>
      
      <div style={{ fontSize: isMobileAndBelow ? '3rem' : '2rem', marginBottom: '1rem' }}>🚀</div>
      
      <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: !isMobileAndBelow ? '3rem' : '4rem', color: '#333', lineHeight: '1.4' }}>
        We can definitely do this!
         {/* {currentGPAValue.toFixed(1)} to {goalGPAValue.toFixed(1)}! */}
      </h2>
      
      {/* GPA Graph Visualization */}
      <div style={{ position: 'relative', height: BAR_HEIGHT_MULTIPLIER * maxGPA * 1.05, margin: '1.5rem auto', marginBottom: '3rem', width: '88%' }}>
        {/* X-axis */}
        <div style={{ position: 'absolute', bottom: '0', width: '100%', height: '2px', backgroundColor: '#ddd' }}></div>
        
        {/* Current GPA Bar */}
        <div style={{ position: 'absolute', bottom: '2px', left: HORIZONTAL_PADDING, width: BAR_WIDTH, backgroundColor: 'var(--color-backgroundTertiary)', borderTopLeftRadius: '4px', borderTopRightRadius: '4px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          { goalGreaterThanCurrent && 
            <div style={{ position: 'absolute', bottom: '100%', fontSize: isMobileAndBelow ? '1rem' : '0.9rem', fontWeight: 'bold', color: 'var(--color-text4)', marginBottom: '5px' }}>{currentGPAValue.toFixed(1)}</div>
          }
          <div style={{ height: `${(effectiveCurrentGPA * BAR_HEIGHT_MULTIPLIER)}px`, animation: 'barRiseCurrent 1.2s ease-out' }}></div>
        </div>
        
        {/* Goal GPA Bar */}
        <div style={{ position: 'absolute', bottom: '2px', right: HORIZONTAL_PADDING, width: BAR_WIDTH, backgroundColor: 'var(--color-text1)', borderTopLeftRadius: '4px', borderTopRightRadius: '4px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          { goalGreaterThanCurrent && 
            <div style={{ position: 'absolute', bottom: '100%', fontSize: isMobileAndBelow ? '1rem' : '0.9rem', fontWeight: 'bold', color: 'var(--color-text1)', marginBottom: '5px' }}
              >{goalGPAValue.toFixed(1)}
            </div>
          }
          <div style={{ height: `${(effectiveGoalGPA * BAR_HEIGHT_MULTIPLIER)}px`, animation: 'barRiseGoal 1.2s ease-out 0.3s both' }}></div>
        </div>
        
        {/* Arrow connecting the bars */}
        <div style={{ position: 'absolute', bottom: '40px', left: '35%', width: '30%', height: '20px', animation: 'fadeIn 0.8s ease-in 1.5s both' }}>
          <div style={{ width: '100%', height: '2px', backgroundColor: 'var(--color-primary)', position: 'relative' }}>
            <div style={{ position: 'absolute', right: '-10px', top: '-4px', width: '0', height: '0', borderTop: '5px solid transparent', borderBottom: '5px solid transparent', borderLeft: '10px solid var(--color-primary)' }}></div>
          </div>
        </div>
        
        {/* Labels below the bars */}
        <div style={{ position: 'absolute', bottom: '-25px', left: HORIZONTAL_PADDING, width: BAR_WIDTH, textAlign: 'center', fontSize: isMobileAndBelow ? '1rem' : '0.9rem', fontWeight: 'bold', color: 'var(--color-text4)', animation: 'fadeIn 0.5s ease-in 0.8s both' }}
          >Current GPA
        </div>
        <div style={{ position: 'absolute', bottom: '-25px', right: HORIZONTAL_PADDING, width: BAR_WIDTH, textAlign: 'center', fontSize: isMobileAndBelow ? '1rem' : '0.9rem', fontWeight: 'bold', color: 'var(--color-text1)', animation: 'fadeIn 0.5s ease-in 1s both' }}
          >Goal GPA
        </div>
      </div>
      
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: isMobileAndBelow ? '5rem' : '3.5rem' }}>
        <div style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: '#f0f0f0', display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '0 0.5rem', fontSize: '1.2rem' }}>📝</div>
        <div style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: '#f0f0f0', display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '0 0.5rem', fontSize: '1.2rem' }}>📚</div>
        <div style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: '#f0f0f0', display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '0 0.5rem', fontSize: '1.2rem' }}>🎯</div>
      </div>

      <p style={{ marginTop: '1rem', color: 'var(--color-text4)', fontSize: '1.1rem', display: 'flex', alignItems: 'center', justifyContent: 'center', lineHeight: '1.4' }}>
        With our tools you'll definitely see a difference.<br />Let's see how they work →
      </p>
      
      <style>
        {`
          @keyframes barRiseCurrent {
            from { height: 0; }
            to { height: ${effectiveCurrentGPA * BAR_HEIGHT_MULTIPLIER}px; }
          }
          @keyframes barRiseGoal {
            from { height: 0; }
            to { height: ${effectiveGoalGPA * BAR_HEIGHT_MULTIPLIER}px; }
          }
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
        `}
      </style>
    </div>
  );
};

const VideoComponent = ({ src, title, subtitle }) => {
  const videoKey = React.useMemo(() => src, [src]);
  
  const [videoLoaded, setVideoLoaded] = useState(false);
  
  return (
    <div style={{ display: "flex", width: '100%', borderRadius: '10px', alignItems: "center", justifyContent: "center", padding: "0 1rem", overflow: "hidden", flexDirection: "column", display: videoLoaded ? 'flex' : 'none' }}>
      {title && 
        <h2 style={{ fontSize: '1.4rem', fontWeight: 'bold', marginBottom: '0.5rem', color: '#333', textAlign: 'center' }}
          >{title}
        </h2>
      }
      
      {subtitle && 
        <p style={{ fontSize: '1rem', color: 'var(--color-text4)', textAlign: 'center', lineHeight: '1.4' }}
          >{subtitle}
        </p>
      }
      <div style={{ display: 'flex', flex: 1, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden', padding: '1rem' }}>
        <video 
          key={videoKey}
          style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', borderRadius: '10px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)' }} 
          autoPlay 
          loop 
          // muted 
          playsInline
          controls
          onLoadedData={() => setVideoLoaded(true)}
        >
          <source src={src} type="video/mp4" />
        </video>
      </div>
    </div>
  );
};

const NoPaymentDueFooter = ({ onClick, buttonText = 'Try for $0.00', priceText = 'Just $29.99 per year ($2.49/mo)' }) => {
  const { isMobileAndBelow } = useBreakpoint();
 
  return (
    <div style={{ display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center', marginTop: "auto" }}>
    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
      <svg xmlns="http://www.w3.org/2000/svg" width={isMobileAndBelow ? '18' : '16'} height={isMobileAndBelow ? '18' : '16'} viewBox="0 0 24 24" fill="none" stroke="var(--color-text1)" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '0.25rem' }}><polyline points="20 6 9 17 4 12"></polyline></svg>
      <span style={{ fontSize: isMobileAndBelow ? '1rem' : '.9rem', color: 'var(--color-text1)', fontWeight: '600' }}>No Payment Due Now</span>
    </div>
    
    <button style={{ width: '100%', padding: isMobileAndBelow ? '1.55rem' : '1.15rem', borderRadius: '.92rem', backgroundColor: '#000', color: '#fff', border: 'none', cursor: 'pointer', fontSize: '1.1rem', fontWeight: 'bold',  }}
      onClick={onClick}
    >
      {buttonText}
    </button>

    {/* <div style={{ fontSize: '0.8rem', color: 'var(--color-text4)', textAlign: 'center', paddingBottom: '.1rem' }}
      >{priceText}
    </div> */}
  </div>
  )
}

const TryForFree = ({ setCurrentStep }) => {
  const { isMobileAndBelow } = useBreakpoint();
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    // Trigger animation after component mounts
    setTimeout(() => setIsVisible(true), 300);
  }, []);

  return (
    <div style={{ width: '100%', display: 'flex', flex: 1, flexDirection: 'column', alignItems: 'center', }}>
      <h2 style={{ fontSize: '1.6rem', fontWeight: 'bold', textAlign: 'center', lineHeight: '1.3' }}
        >We want you to<br/>try School Goat <u>for free</u>.
      </h2>

      <div style={{ width: '100%', display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center', }}>
        <img 
          src={SchoolGoat} 
          alt="School Goat Screenshot" 
          style={{ 
            width: '100%', 
            maxWidth: isMobileAndBelow ? '380px' : '250px', 
            height: 'auto', 
            margin: 'auto',
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'scale(1) rotate(0deg)' : 'scale(0.5) rotate(-10deg)',
            transition: 'opacity 0.8s ease-out, transform 0.8s cubic-bezier(0.34, 1.56, 0.64, 1)',
            boxShadow: isVisible ? '0 10px 25px rgba(0, 0, 0, 0.1)' : 'none',
            borderRadius: '1rem'
          }} 
        />
      </div>

      <NoPaymentDueFooter onClick={() => setCurrentStep((prev) => prev + 1)} />
    </div>
  )
}

const Reminder = ({ setCurrentStep }) => {
  const { isMobileAndBelow } = useBreakpoint();

  return (
    <div style={{ width: '100%', display: 'flex', flex: 1, flexDirection: 'column', alignItems: 'center',  }}>
      <h2 style={{ fontSize: '1.6rem', fontWeight: 'bold', textAlign: 'center', lineHeight: '1.3' }}
        >We'll send you a reminder<br/>before your trial ends.
      </h2>

      <div style={{ width: '100%', display: 'flex', flex: 1,justifyContent: 'center', alignItems: 'center' }}>
        {/* <img src={SchoolGoat} alt="CalAI App Screenshot" style={{ width: '100%', maxWidth: isMobileAndBelow ? '380px' : '250px', height: 'auto', margin: 'auto'  }} /> */}
        <iframe src="https://lottie.host/embed/4f4218fc-40ca-4b24-82d6-b133961c4a6e/Sm1G2tZUOO.lottie" style={{ width: '100%', height: '80%', maxWidth: isMobileAndBelow ? '380px' : '280px', margin: 'auto', border: 'none', overflow: 'hidden' }}></iframe>
      </div>

      <NoPaymentDueFooter onClick={() => setCurrentStep((prev) => prev + 1)} />
    </div>
  )
}

const Paywall = ({  }) => {
  const { user, paddle } = useContext(UserContext);
  const { isMobileAndBelow } = useBreakpoint();

  const [plans, setPlans] = useState({
    monthly: { _id: 'pri_01jqcc3ax52997cs887th4skej', _idTest: 'pri_01jqc7r2rqsrxw4n88w19hmxze', discounted_id: "pri_01jrg4zw3zcwws6d2y4f3bvc7w", discounted_idTest: "pri_01jrg477ej72dy76ner3aae0b3", label: 'Monthly', total: '14.99', totalFormatted: '$14.99', currencySymbol: '$', tag: '',  },
    yearly: { _id: 'pri_01jqcc44ht7d0f56b012cxm10s', _idTest: 'pri_01jqc7rr5m5k51b131cng529wx', discounted_id: "pri_01jrg50prrwx60kp1zz0twh4dc", discounted_idTest: "pri_01jrg454fppbx5axbhwmevnse9", label: 'Yearly', total: '7.49', totalFormatted: '$7.49', currencySymbol: '$', tag: '6 months free',  },
  });
  const [selectedPlan, setSelectedPlan] = useState(plans.yearly);
  const isReferral = user?.promoter?.wasReferral ? true : false;

  const getEffectivePriceId = (plan) => {
    const isProduction = process.env.REACT_APP_NODE_ENV === 'production';

    if (isProduction) {
      if (isReferral) {
        return plan.discounted_id;
      }
      return plan._id;
    }
    else {
      if (isReferral) {
        return plan.discounted_idTest;
      }
      return plan._idTest;
    }
  }
  
  useEffect(() => {
    const fetchPrices = async () => {
      if (!paddle || !user) return;
      
      try {
        const results = await Promise.all([
          getPriceObj(paddle, user, getEffectivePriceId(plans.monthly)),
          getPriceObj(paddle, user, getEffectivePriceId(plans.yearly))
        ]);

        console.log(results)
        
        setPlans(prevPlans => ({
          monthly: { ...prevPlans.monthly, ...results[0] },
          yearly: { ...prevPlans.yearly, ...results[1] }
        }));
      } catch (error) {
        console.error('Error fetching prices:', error);
      } finally {
      }
    };
    
    fetchPrices();
  }, [paddle, user]);

  const handlePlanClick = async () => {
    if (!paddle) return;

    try {
      await Promise.allSettled([
        logPaywallAction({ user, eventType: PAYWALL_EVENTS.CHECKOUT, type: 'paddle'}),
      ]);
    }
    catch (error) {
    }

    Pixel.track('InitiateCheckout');

    const priceId = getEffectivePriceId(selectedPlan);

    const checkoutOptions = {
      items: [ { priceId: priceId, quantity: 1 } ],
      
      settings: {
        theme: 'light',  
        successUrl: `${process.env.REACT_APP_FRONTEND_URL}/app/home?${SEARCH_PARAMS.checkout_success}=${user?._id}&${SEARCH_PARAMS.payment_provider}=paddle`,
        variant: isMobileAndBelow ? "one-page" : "multi-page"
      },
      customer: {
        email: user?.email || 'test@test.com',
        address: {
          postalCode: user?.authData?.postal || '12345',
          countryCode: user?.authData?.country_code || 'US',
        }
      },
      // discountId: "",
      customData: {
        mongo_id: user?._id,
        mongo_email: user?.email,
      }
      };

    paddle.Checkout.open(checkoutOptions);
  };

  const GraphicIcon = ({ Icon, color }) => {
    return (
      <div style={{ width: '34px', height: '34px', borderRadius: '50%', backgroundColor: color, display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 2 }}>
        <Icon color="white" size={18} />
      </div>
    )
  }

  const GraphicLine = ({ color }) => {
    const CONNECTOR_LINE_HEIGHT = isMobileAndBelow ? '4rem' : '7dvh';

    return (
      <div style={{ width: '10px', height: CONNECTOR_LINE_HEIGHT, background: color, zIndex: 1, borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px' }}></div>
    )
  }

  return (
    <div style={{ width: '100%', display: 'flex', height: "100%", flexDirection: 'column',   }}>
      <h2 style={{ fontSize: '1.6rem', fontWeight: 'bold', textAlign: 'center', lineHeight: '1.3', flexShrink: 0 }}
        >Start your 3-day FREE trial{!isReferral && <><br/> to continue</>}
      </h2>

      {isReferral && (
        <div style={{ backgroundColor: '#e6f7ff', color: '#0066cc', padding: '0.75rem 1rem', borderRadius: '0.5rem', marginTop: '0.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center', animation: 'fadeIn 0.8s ease-out', textAlign: 'center', lineHeight: '1.2' }}>
          <span style={{ fontWeight: '500' }}>Congratulations! The referral saves you 20%!</span>
        </div>
      )}

      <div style={{ width: '100%', display: 'flex', flex: 1, flexDirection: 'column', marginTop: '1rem', alignItems: 'center' }}>

          <div style={{ width: '100%', maxWidth: '400px', display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '20px', padding: '0 1rem', animation: 'fadeIn 0.8s ease-out' }}>
            
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative', width: '100%' }}>
              {[
                { icon: Lock, iconColor: "var(--color-primary)", lineColor: "var(--color-primaryLight)", label: "Today", description: "Unlock all the app's features like automatic note-taking and more." },
                { icon: Bell, iconColor: "var(--color-primary)", lineColor: "var(--color-primaryLight)", label: "Reminder", description: "We'll send you a reminder that your trial is ending soon." },
                { icon: Crown, iconColor: "black", lineColor: "rgba(0, 0, 0, 0.1)", label: "In 3 Days - Billing Starts", description: "You'll be charged this day unless you cancel anytime before (easy to cancel directly on site)." }
              ].map((item, index) => (
                <div key={index} style={{ display: 'flex', flexDirection: 'row', width: '100%', marginTop: index != 0 ? '-5px' : '0px', animation: `slideInRight 0.5s ease-out ${0.3 + index * 0.2}s both` }}>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <GraphicIcon Icon={item.icon} color={item.iconColor} />
                    <GraphicLine color={item.lineColor} />
                  </div>
                  
                  <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '15px', paddingTop: '.5rem' }}>
                    <span style={{ fontSize: isMobileAndBelow ? '1.2rem' : '1rem', color: 'var(--color-text1)' }}>{item.label}</span>
                    <span style={{ color: 'var(--color-text4)', fontSize: isMobileAndBelow ? '1rem' : '0.9rem', marginTop: '0.25rem', lineHeight: '1.2' }}>{item.description}</span>
                  </div>
                </div>
              ))}
            </div>
          
          </div>
          
          <div style={{ width: '90%', display: 'flex', justifyContent: 'space-between', gap: '1rem', marginTop: 'auto', marginBottom: '2rem', animation: 'fadeInUp 0.8s ease-out 1s both' }}>
            {Object.values(plans).map((plan, index) => {
              const isSelected = selectedPlan.label === plan.label;
              const borderColor = isSelected ? '#000' : '#ddd';

              return (
                <div key={index} style={{ flex: 1, border: `3px solid ${borderColor}`, borderRadius: '.9rem', padding: '1.5rem 1.25rem', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', position: 'relative', width: "100%", cursor: 'pointer', transition: 'transform 0.3s ease, box-shadow 0.3s ease', transform: isSelected ? 'scale(1.03)' : 'scale(1)', boxShadow: isSelected ? '0 4px 12px rgba(0,0,0,0.15)' : 'none' }}
                  onClick={() => setSelectedPlan(plan)}
                >
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span style={{ fontSize: '1rem', fontWeight: 'bold', color: 'var(--color-text1)' }}
                      >{plan.label}
                    </span>
                    <span style={{ fontSize: '1rem', color: 'var(--color-text2)', marginTop: '0.5rem' }}
                      >{plan.totalFormatted}/mo
                    </span>
                    {isReferral && (
                      <span style={{ fontSize: '0.8rem', color: 'var(--color-text3)', marginTop: '0.35rem', fontWeight: '500', lineHeight: '1.2' }}>Regular price <span style={{ textDecoration: 'line-through' }}>{plan.currencySymbol}{(plan.total/0.8).toFixed(2)}/mo</span></span>
                    )}
                  </div>
                  <div style={{ width: '24px', height: '24px', borderRadius: '50%', border: `2px solid ${borderColor}`, display: 'flex', justifyContent: 'center', alignItems: 'center', transition: 'all 0.3s ease' }}>
                    {isSelected ? (
                      <div style={{ width: '20px', height: '20px', borderRadius: '50%', backgroundColor: '#000', display: 'flex', justifyContent: 'center', alignItems: 'center', animation: 'popIn 0.4s ease-out' }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{  }}><polyline points="20 6 9 17 4 12"></polyline></svg>
                      </div>
                    ) : (
                      <div style={{ width: '20px', height: '20px', borderRadius: '50%', border: 'none' }}></div>
                    )}
                  </div>

                  {plan.tag && (
                    <div style={{ position: 'absolute', top: '-1rem', right: '1rem', fontSize: '0.9rem', color: 'white', padding: '0.5rem .75rem', backgroundColor: 'black', borderRadius: '0.5rem', animation: 'pulse 2s infinite' }}
                      >{plan.tag}
                    </div>
                  )}
                </div>
              )
            })}
          </div>

      </div>
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
          
          @keyframes slideInRight {
            from { transform: translateX(-20px); opacity: 0; }
            to { transform: translateX(0); opacity: 1; }
          }
          
          @keyframes fadeInUp {
            from { transform: translateY(20px); opacity: 0; }
            to { transform: translateY(0); opacity: 1; }
          }
          
          @keyframes popIn {
            0% { transform: scale(0); }
            70% { transform: scale(1.2); }
            100% { transform: scale(1); }
          }

        `}
      </style>

      <NoPaymentDueFooter 
        onClick={() => handlePlanClick()} 
        buttonText="Start My 3-Day Free Trial" 
        priceText={`Just ${selectedPlan.totalFormatted} per ${selectedPlan.label}${user?.promoter?.eligibleForDiscount ? ' (20% off)' : ''}`} 
      />
    </div>
  )
}

const CheckoutAbandoned = ({  }) => {
  const { user, paddle, setShowCheckoutAbandonedModal } = useContext(UserContext);
  const { isMobileAndBelow } = useBreakpoint();
  const [plans, setPlans] = useState({
    yearly: { _id: 'pri_01jqcc50xh5zevgyydkjcmkvf2', _idTest: 'pri_01jqc86x0vy1xqzasqwd994ave', label: 'Yearly', price: '$4.49', tag: '6 months free' },
  });
  const [selectedPlan, setSelectedPlan] = useState(plans.yearly);
  
  useEffect(() => {
    const fetchPrices = async () => {
      if (!paddle || !user) return;
      
      try {
        const isProduction = process.env.REACT_APP_NODE_ENV === 'production';
        const result = await getPriceObj(paddle, user, isProduction ? plans.yearly._id : plans.yearly._idTest);
        
        setPlans(prevPlans => ({
          yearly: { 
            ...prevPlans.yearly, 
            ...result,
          }
        }));
        setSelectedPlan(prevSelectedPlan => ({
          ...prevSelectedPlan,
          ...result,
        }));
      } catch (error) {
        console.error('Error fetching prices:', error);
      } finally {
      }
    };
    
    fetchPrices();
  }, [paddle, user]);

  const handlePlanClick = async () => {
    if (!paddle) return;

    try {
      await Promise.allSettled([
        logPaywallAction({ user, eventType: PAYWALL_EVENTS.CHECKOUT, type: 'paddle'}),
      ]);
    }
    catch (error) {
    }

    Pixel.track('InitiateCheckout');

    const checkoutOptions = {
      items: [ { priceId: process.env.REACT_APP_NODE_ENV === 'production' ? selectedPlan._id : selectedPlan._idTest, quantity: 1 } ],
      
      settings: {
        theme: 'light',  
        successUrl: `${process.env.REACT_APP_FRONTEND_URL}/app/home?${SEARCH_PARAMS.checkout_success}=${user?._id}&${SEARCH_PARAMS.payment_provider}=paddle`,
        variant: isMobileAndBelow ? "one-page" : "multi-page"
      },
      customer: {
        email: user?.email || 'test@test.com',
        address: {
          postalCode: user?.authData?.postal || '12345',
          countryCode: user?.authData?.country_code || 'US',
        }
      },
      discountId: "",
      customData: {
        mongo_id: user?._id,
        mongo_email: user?.email,
      }
      };

    paddle.Checkout.open(checkoutOptions);
  };

  const GIFT_BUTTON_CONTAINER_SIZE = !isMobileAndBelow ? '60px' : '80px';
  const GIFT_BUTTON_CONTAINER_TOP_POSITION = !isMobileAndBelow ? '-30px' : '-40px';
  const GIFT_BUTTON_SIZE = !isMobileAndBelow ? 36 : 42;

  return (
    <div style={{ width: '100%', display: 'flex', flex: 1, flexDirection: 'column', alignItems: 'center',  }}>

      <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '1rem', cursor: 'pointer', width: '100%' }}
        onClick={() => setShowCheckoutAbandonedModal(false)}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#888888" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </div>

      <h2 style={{ fontSize: '2.8rem', fontWeight: '600', textAlign: 'center', lineHeight: '1.3' }}
        >One Time Offer
      </h2>

      <div style={{ fontSize: '1.4rem', color: 'var(--color-text2)', textAlign: 'center', margin: '1rem 0', width: '100%' }}>
        <span style={{  }}>You will never see this again!</span>
      </div>



      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: "100%", position: 'relative', height: '100%'}}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', maxWidth: '400px', backgroundColor: '#f5f5f5', borderRadius: '1.5rem', padding: '3rem 1.5rem', position: 'relative', height: "80%", animation: 'cardAppear 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) forwards', opacity: 0, transform: 'scale(0.8)' }}>
          <div style={{ position: 'absolute', top: GIFT_BUTTON_CONTAINER_TOP_POSITION, width: GIFT_BUTTON_CONTAINER_SIZE, height: GIFT_BUTTON_CONTAINER_SIZE, borderRadius: '50%', backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)', border: '1px solid var(--color-backgroundTertiary)', animation: 'giftBounce 1s ease-out 0.5s forwards', opacity: 0, transform: 'translateY(-20px)' }}>
            <Gift size={GIFT_BUTTON_SIZE} color="var(--color-primary)" strokeWidth={1.5} style={{ animation: 'giftPulse 2s infinite 1.5s' }} />
          </div>
          
          <div style={{ width: '100%', textAlign: 'center', marginTop: '1rem', animation: 'fadeSlideUp 0.5s ease-out 0.9s forwards', opacity: 0, transform: 'translateY(15px)' }}>
            <span style={{ fontSize: '1.4rem' }}>Here's a <span style={{ backgroundColor: 'black', color: 'white', padding: '0.5rem 0.95rem', borderRadius: '20px', fontWeight: 'bold', animation: 'highlight 1s ease-out 1.5s' }}
              >70% off</span> discount 🙌</span>
          </div>
          
          <div style={{ backgroundColor: 'white', width: '100%', padding: '1.5rem', borderRadius: '1rem', textAlign: 'center', margin: '1.5rem 0 0 0', animation: 'fadeSlideUp 0.5s ease-out 1.1s forwards', opacity: 0, transform: 'translateY(15px)', color: 'var(--color-text1)' }}>
            <span style={{ fontWeight: 'bold', fontSize: '1.4rem' }}>Only {selectedPlan.totalFormatted}/mo</span>
          </div>
          
          <span style={{ fontSize: '1rem', color: 'gray', marginTop: '1.5rem', animation: 'fadeSlideUp 0.5s ease-out 1.3s forwards', opacity: 0, transform: 'translateY(15px)' }}>Lowest price ever</span>
          
        </div>

        <style>
          {`
            @keyframes cardAppear {
              0% { opacity: 0; transform: scale(0.8); }
              100% { opacity: 1; transform: scale(1); }
            }
            @keyframes giftBounce {
              0% { opacity: 0; transform: translateY(-20px); }
              50% { opacity: 1; transform: translateY(10px); }
              75% { transform: translateY(-5px); }
              100% { opacity: 1; transform: translateY(0); }
            }
            @keyframes fadeSlideUp {
              0% { opacity: 0; transform: translateY(15px); }
              100% { opacity: 1; transform: translateY(0); }
            }
            @keyframes giftPulse {
              0% { transform: scale(1); }
              50% { transform: scale(1.1); }
              100% { transform: scale(1); }
            }
            @keyframes highlight {
              0% { transform: scale(1); }
              50% { transform: scale(1.1); box-shadow: 0 0 15px rgba(0,0,0,0.3); }
              100% { transform: scale(1); }
            }
          `}
        </style>
      </div>

      <div style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%', pointerEvents: 'none', overflow: 'hidden', borderRadius: '16px' }}>
        {Array.from({ length: 1200 }).map((_, i) => (
          <div key={i} style={{ 
            position: 'absolute', 
            width: '6px', 
            height: '6px', 
            backgroundColor: ['#a3e635', '#22d3ee', '#fcd34d'][i % 3], 
            borderRadius: '50%',
            top: `-10%`,
            left: `${Math.random() * 100}%`,
            animation: `fall${i % 2} ${0.8 + Math.random() * 1.2}s linear forwards`,
            animationDelay: `${Math.random() * 1.5}s`
          }}></div>
        ))}
        <style>
          {`
            @keyframes fall0 {
              0% { transform: translateY(0) rotate(0deg); top: -10%; opacity: 1; }
              90% { opacity: 1; }
              100% { transform: translateY(110vh) rotate(360deg); top: 110%; opacity: 0; }
            }
            @keyframes fall1 {
              0% { transform: translateY(0) rotate(0deg); top: -10%; opacity: 1; }
              90% { opacity: 1; }
              100% { transform: translateY(110vh) rotate(-360deg); top: 110%; opacity: 0; }
            }
            @keyframes fall2 {
              0% { transform: translateY(0) rotate(0deg); top: -10%; opacity: 1; }
              90% { opacity: 1; }
              100% { transform: translateY(110vh) rotate(180deg); top: 110%; opacity: 0; }
            }
          `}
        </style>
        <style>
          {`
            @keyframes hideAfter4Seconds {
              0%, 99% { opacity: 1; }
              100% { opacity: 0; visibility: hidden; }
            }
          `}
        </style>
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', animation: 'hideAfter4Seconds 2.5s forwards' }}></div>
      </div>
    

      <NoPaymentDueFooter 
        onClick={() => handlePlanClick()} 
        buttonText="Claim your limited offer now!" 
        priceText={`Just ${selectedPlan.totalFormatted} per ${selectedPlan.label}`} 
      />
    </div>
  )
}

const OnboardingScreen = () => {
  const { showCheckoutAbandonedModal, user } = useContext(UserContext);
  const [currentStep, setCurrentStep] = useState(0);
  const [currentGPA, setCurrentGPA] = useState('');
  const [goalGPA, setGoalGPA] = useState('');
  const [educationLevel, setEducationLevel] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [school, setSchool] = useState('');
  
  const { isMobileAndBelow } = useBreakpoint();

  const CONTAINER_STYLE = { display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: isMobileAndBelow ? '100dvh' : '90vh', width: isMobileAndBelow ? '100%' : '80%', maxWidth: '500px', margin: 'auto', backgroundColor: '#fff', padding: '1rem', borderRadius: isMobileAndBelow ? '0' : '10px', boxShadow: isMobileAndBelow ? 'none' : '0 4px 8px rgba(0, 0, 0, 0.1)', position: 'relative' }
  const [studentCount, setStudentCount] = useState(42154);


  useEffect(() => {
    if (user?._id) {
      initLogging();
    }
  }, [user?._id]);


  const initLogging = async () => {
    Promise.allSettled([
      axios.put(`${API}/generalUpdateOne`, {
        matchObj: { _id: user?._id },
        updateObj: { $set: { 'testId': USER_TEST_ID } },
        dbRef: dbRefs.users,
      }),
      logPaywallAction({ user, eventType: PAYWALL_EVENTS.PAYWALL_SHOWN, funnel: 'hardPaywall' }),
    ]);
  }


  useEffect(() => {
    if (educationLevel) {
      // Calculate student count based on education level
      let count = 0;
      if (educationLevel === 'university') {
        count = getRandomNumberBetween(30000, 40000);
      } else if (educationLevel === 'high_school') {
        count = getRandomNumberBetween(10000, 20000);
      } else if (educationLevel === 'middle_school') {
        count = getRandomNumberBetween(5000, 10000);
      } else {
        count = getRandomNumberBetween(1000, 5000);
      }
      setStudentCount(count);
    }
  }, [educationLevel]);

  // grade level, school select, [ x people in your school are using School Goat ]
  // current gpa, goal gpa, [ we can definitely help you get there ]
  // [first let's show you how to use it], [take notes gif], [study tools gif], [ paywall setup], paywall options

  const stepsAll = [   
    {
      label: 'Your grade level',
      component: (
        <SelectableOptions
          value={educationLevel}
          options={[
            { label: 'University', value: 'university', isShaded: true },
            { label: 'High School', value: 'high_school', isShaded: true },
            { label: 'Middle School', value: 'middle_school', isShaded: true },
            { label: "I'm not a student", value: 'not_a_student' },
          ]}
          onSelect={(value) => {
            setEducationLevel(value);
            setCurrentStep(currentStep + 1); // Just go to next step
          }}
        />
      ),
    },

    { label: '', component: <EducationTypePopularity educationLevel={educationLevel} studentCount={studentCount} />, showButton: true },
    
    // { label: 'School Picker', component: <div style={{ width: '100%', height: '200px', backgroundColor: '#f0f0f0', borderRadius: '10px', marginBottom: '1rem' }}>Insert school picker</div> },
    // { label: '', component: <SchoolPopularity educationLevel={educationLevel} school={school} />, showButton: true },
    
    { label: `What's your current GPA?`, component: <TextInput placeholder="3.2" value={currentGPA} onSelect={setCurrentGPA} keyboardType="number" />, showButton: true, onlyUS: true },
    { label: `What's your goal GPA?`, component: <TextInput placeholder="3.9" value={goalGPA} onSelect={setGoalGPA} keyboardType="number" />, showButton: true, onlyUS: true },
    { label: '', component: <GPAVisualization currentGPA={currentGPA} goalGPA={goalGPA} />, showButton: true, onlyUS: true },
    
    // https://academicweapon.s3.us-east-1.amazonaws.com/admin/Demo-StudyToolsDeep.mp4
    // https://academicweapon.s3.us-east-1.amazonaws.com/admin/Demo-LiveLectureDeep.mp4

    // short
    // https://academicweapon.s3.us-east-1.amazonaws.com/admin/NotesDemo3.mp4
    // https://academicweapon.s3.us-east-1.amazonaws.com/admin/StudyDemo2.mp4

    { label: '', component: <VideoComponent src={'https://academicweapon.s3.us-east-1.amazonaws.com/admin/Demo-LiveLectureDeep.mp4'} title="Get Perfect Lecture Notes" subtitle="Automatic note taking will catch everything for you" />, showButton: true },
    { label: '', component: <VideoComponent src={'https://academicweapon.s3.us-east-1.amazonaws.com/admin/Demo-StudyToolsDeep.mp4'} title="Ace Your Exams" subtitle="Get personalized study materials for your classes" />, showButton: true },


    { label: '', component: <TryForFree setCurrentStep={setCurrentStep} /> },
    { label: '', component: <Reminder setCurrentStep={setCurrentStep} /> },

    { label: '', component: <Paywall setCurrentStep={setCurrentStep} /> },
  ];

  const filterSteps = () => {
    const isUS = user?.authData?.country_name === "United States";
    return stepsAll.filter(step => !step.onlyUS || ( isUS && educationLevel !== 'not_a_student' ));
  }

  const steps = filterSteps();

  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  if ( showCheckoutAbandonedModal ) return (
    <div style={CONTAINER_STYLE}>
      <CheckoutAbandoned />
    </div>
  )
  
  else return (
    <div style={CONTAINER_STYLE}>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', marginBottom: '1rem' }}>
        <button onClick={() => currentStep > 0 && setCurrentStep(currentStep - 1)} style={{ padding: '0', borderRadius: '50px', backgroundColor: 'transparent', color: currentStep > 0 ? '#888' : '#ccc', border: 'none', cursor: currentStep > 0 ? 'pointer' : 'default', opacity: currentStep > 0 ? '1' : '0' }}
          ><ChevronLeft color="var(--color-text4)" size={isMobileAndBelow ? 26 : 20} />
        </button>
        <div style={{ height: '4px', backgroundColor: '#ccc', borderRadius: '2px', flex: 1, margin: '0 1rem' }}>
          <div style={{ width: `${((currentStep + 1) / steps.length) * 100}%`, height: '100%', backgroundColor: '#000', borderRadius: '2px', transition: 'width 0.3s ease-in-out' }}></div>
        </div>
        <button style={{ padding: '0', borderRadius: '50px', backgroundColor: 'transparent', color: currentStep < steps.length - 1 ? '#888' : '#ccc', border: 'none', cursor: currentStep < steps.length - 1 ? 'pointer' : 'default', 
          // opacity: currentStep < steps.length - 1 ? '1' : '0.5',
          opacity: 0,
          }}
          // onClick={() => currentStep < steps.length - 1 && setCurrentStep(currentStep + 1)} 
          ><ChevronRight color="var(--color-text4)" size={isMobileAndBelow ? 26 : 20} />
        </button>
      </div>
      
      <div style={{ width: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", flex: 1, overflow: 'auto' }}>
        
        { steps[currentStep].label && (
          <h1 style={{ fontSize: '1.2rem', fontWeight: '600', marginBottom: '1.5rem' }}
            >{steps[currentStep].label}
          </h1>
        )}

        {React.cloneElement(steps[currentStep].component, { currentStep, setCurrentStep })}

      </div>

      {steps[currentStep].showButton && (
        <div style={{ width: "100%", marginTop: '1rem', borderTop: '1px solid #eee', paddingTop: '1rem', position: isMobileAndBelow ? 'sticky' : 'relative', bottom: 0, backgroundColor: '#fff', zIndex: 10 }}>
          <button onClick={handleNext} style={{ width: "100%", padding: '1.25rem 2rem', borderRadius: '50px', backgroundColor: '#000', color: '#fff', border: 'none', cursor: 'pointer', fontSize: '1rem' }}
          >Next
          </button>
        </div>
      )}
      
    </div>
  );
};

export default OnboardingScreen;



// const ConfettiText = ({ text }) => {
//   const [showConfetti, setShowConfetti] = useState(true);
  
//   React.useEffect(() => {
//     // Hide confetti after 3 seconds
//     const timer = setTimeout(() => {
//       setShowConfetti(false);
//     }, 3000);
    
//     return () => clearTimeout(timer);
//   }, []);
  
//   return (
//     <div style={{ width: '100%', textAlign: 'center', position: 'relative', padding: '2rem 1rem', maxWidth: '400px' }}>
//       <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '1rem', color: '#333' }}>{text}</h2>
      
//       {showConfetti && (
//         <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, pointerEvents: 'none', overflow: 'hidden', zIndex: 10 }}>
//           {Array.from({ length: 50 }).map((_, i) => {
//             const size = Math.random() * 10 + 5;
//             const left = Math.random() * 100;
//             const animationDuration = Math.random() * 3 + 2;
//             const delay = Math.random() * 1;
//             const color = ['#ff0000', '#00ff00', '#0000ff', '#ffff00', '#ff00ff', '#00ffff'][Math.floor(Math.random() * 6)];
            
//             return (
//               <div key={i} style={{ 
//                 position: 'absolute', 
//                 width: `${size}px`, 
//                 height: `${size}px`, 
//                 backgroundColor: color, 
//                 borderRadius: '50%', 
//                 left: `${left}%`, 
//                 top: '-20px',
//                 opacity: Math.random() * 0.7 + 0.3,
//                 animation: `fall ${animationDuration}s linear ${delay}s forwards`,
//               }} />
//             );
//           })}
//         </div>
//       )}
      
//       <style>
//         {`
//           @keyframes fall {
//             0% { transform: translateY(-20px) rotate(0deg); }
//             100% { transform: translateY(400px) rotate(360deg); }
//           }
//         `}
//       </style>
//     </div>
//   );
// };




{/* <div style={{ height: '4px', backgroundColor: '#ccc', borderRadius: '2px', marginBottom: '1rem' }}>
          <div style={{ width: `${((currentStep + 1) / steps.length) * 100}%`, height: '100%', backgroundColor: '#007bff', borderRadius: '2px' }}></div>
        </div> */}